import { render } from "./batchAdd.vue?vue&type=template&id=905912f6&scoped=true"
import script from "./batchAdd.vue?vue&type=script&lang=js"
export * from "./batchAdd.vue?vue&type=script&lang=js"

import "./batchAdd.vue?vue&type=style&index=0&id=905912f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905912f6"]])

export default __exports__